import axios from 'axios'
import store from '@/store/store'

// Создаем axios instance. Все запросы и перехваты будем вести только через этот инстанс
const apiClient = axios.create({
  baseURL: process.env.VUE_APP_DRF_BASE_URL,

  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

//Сразу запускаем перехват на все ответы. Интересоваать нас будут отвветы 401
apiClient.interceptors.response.use(
  response => response, // Если ошибок нет, то просто возвращаем ответ как есть
  error => {
    // Пока нас интересуют только 401 ошибки, так что все остальные пропускаем дальше, как есть

    if (!error.response) {
      return new Promise((resolve, reject) => {
        reject(error)
      })
    }
    if (error.response.status !== 401) {
      return new Promise((resolve, reject) => {
        reject(error)
      })
    }
    console.log('401 error intercepted')
    // И так, нас послали по 401 ошибке. Т.е. дали отлуп при попытке достучатьс до какого-то API.
    // Интересно, что даже если это API доступно для всех, но у нас протух Access Token, то нас все авно не пускают
    // А вот еслиб мы зашли вообще без токена, то пустили бы. Возможно есть какие-то настройки, но по дефолту работает вот так.

    //Проверим не от попытки отрешрешить Access Token ли этот отлуп
    if (error.config.url == '/auth/token/refresh/') {
      console.log('401 after refresh token')
      // Так и есть. Т.е. мы уже пытались отрефрешить токен, но нас и тут послали.
      // Это значит, что портух уже и RefreshToken и надо сновва логинитьс.
      // Поэтому надо логаутить пользователя.
      store.dispatch('logout')
      return new Promise((resolve, reject) => {
        reject(error)
      })
    }

    //А вот это нас послали в первый раз с протухшим Access Token и нам надо попробовать получить новый по рефрешу.
    console.log('Trying to get new access token')
    return apiClient
      .post('/auth/token/refresh/', {
        refresh: store.getters.getRefreshToken
      })
      .then(({ data }) => {
        // Получаем новый Access Token.
        // Теперь его надо записать в store и пеердать дальше тотже самый реквест, который отлупили по 401, но с новым Access Token  в хедере
        // Напомним, что компонент,
        // в котоорм был вызван API в который нас не пустили,
        // так и грустно сидит и ждет пока мы тут пытаемся наковырять новый Access Token и отпустить уже его запрос к API, повторив его
        return store
          .dispatch('setNewAccessToken', data.access)
          .then(function() {
            // запихиваем в конфиг, в ктором произошла ошибка, новый хедер и повторем реквест
            error.config.headers['Authorization'] =
              apiClient.defaults.headers.common['Authorization']
            return apiClient.request(error.config)
          })
      })
      .catch(error => {
        // Что-то пошло не так и нам по непонятной причине не дали новвый Access Token
        // Логаутим пользователя
        console.log('Error getting new access token:', error)
        store.dispatch('logout')
        return new Promise((resolve, reject) => {
          reject(error)
        })
      })
  }
)

export default {
  setAuthorizationHeader(token) {
    apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`
  },

  clearAuthorizationHeader() {
    apiClient.defaults.headers.common['Authorization'] = null
  },

  //--------------------------------------------
  //  API вызовы использующиеся при авторизации
  //--------------------------------------------

  // Отправлем в API номерр мобильного телефона и определяем есть пользователь с таким телефоном или нет
  getUser(phonenumber) {
    return apiClient.get('/api/user/' + phonenumber)
  },

  // Отправлем в API номеер мобильного телефона для посылки на него кода
  // Ничего не возвращает
  sendVerificationCodeByEmail(email) {
    return apiClient.post('/nopassauth/email/', { email: email })
  },

  // Отправлем в API номеер мобильного телефона для посылки на него кода
  // Ничего не возвращает
  sendVerificationCodeByMobile(mobile) {
    return apiClient.post('/nopassauth/mobile/', { mobile: mobile })
  },

  // Отправлем в API telegram id для посылки на него кода
  // Ничего не возвращает
  sendVerificationCodeByTelegram(telegramid) {
    return apiClient.post('/nopassauth/telegram/', { telegramid: telegramid })
  },

  // Отпрраввляем в API пару (номер мобильного и код) для определения валидности кода
  // Возвращает JWT токен
  obtainTokensByMobileCode(mobile, code) {
    console.log('Obtain tokens:', mobile, code)
    return apiClient.post('/nopassauth/token/', { mobile: mobile, token: code })
  },

  //--------------------------------------------------
  // API вызовы admin сервисов
  //--------------------------------------------------

  // Получаем список всех администраторов
  // Используется для наполнения списка возможнных авторов артиклов
  getAdministrators() {
    return apiClient.get('/api/administrators/')
  },

  getVersion() {
    return apiClient.get('/api/versions/')
  },

  //--------------------------------------------------
  // API вызовы получения данных путешествий
  //--------------------------------------------------

  // Получаем список всез путешеествий
  // Используется в Countries.vue
  getJourneys() {
    return apiClient.get('/api/journey/')
  },

  // Получаем список всез трипс
  // Используется в Countries.vue вместо getJourneys
  getTrips() {
    return apiClient.get('/api/trip/')
  },

  // Получаем данные путешествия по его ID
  // Используется в Journey
  getJourneyInfo(journey_id) {
    return apiClient.get('/api/journeyinfo/' + journey_id)
  },

  // Получаем список персонов для которых мы имеем и показываем полную статистику зарубежных поездок
  // Используется в Countries.vue
  getPersonsWithFullCountriesStatistics() {
    return apiClient.get('/api/personswithfullcountriesstatistics/')
  },

  getYearsWithJourneys() {
    return apiClient.get('/api/yearswithjourneys')
  },

  getCountriesWithJourneys() {
    return apiClient.get('/api/countrieswithtrips')
  },

  getJourneyTitles() {
    return apiClient.get('/api/journeywitharticlesnames')
  },

  getJourneyPreviews(filterOptions) {
    let filterString = ''
    Object.keys(filterOptions).forEach(key => {
      filterString += '&' + key + '=' + filterOptions[key]
    })
    return apiClient.get('/api/previewjourneys/?' + filterString)
  },

  //--------------------------------------------------
  // API вызовы получения и изменения данных артиклов и связанных с ними элементов
  //--------------------------------------------------

  getArticles(filterOptions, page) {
    let filterString = ''
    Object.keys(filterOptions).forEach(key => {
      filterString += '&' + key + '=' + filterOptions[key]
    })
    console.log('/api/articles/?page=' + page + filterString)
    return apiClient.get('/api/articles/?page=' + page + filterString)
  },

  getArticleTitles(filterOptions) {
    let filterString = ''
    Object.keys(filterOptions).forEach(key => {
      filterString += '&' + key + '=' + filterOptions[key]
    })

    return apiClient.get('/api/previewarticles/?' + filterString)
  },

  getArticleIds(filterOptions) {
    let filterString = ''
    Object.keys(filterOptions).forEach(key => {
      filterString += '&' + key + '=' + filterOptions[key]
    })
    return apiClient.get('/api/articleids/?journey_id=null' + filterString)
  },

  getYearsWithArticles() {
    return apiClient.get('/api/yearswitharticles')
  },

  // Получаем список всех тагов
  // Используется в поиске по тагам
  getTags() {
    return apiClient.get('/api/tag/')
  },

  getHomeLocations() {
    return apiClient.get('/api/locations/?parent_location=101') //богомерзкий хардкод
  },

  getJourneyLocations() {
    return apiClient.get('/api/locations/?exclude_parent_location=101')
  },

  getArticle(articleId) {
    return apiClient.get('/api/article/' + articleId)
  },

  // Редактируем артикл
  updateArticle(articleId, article) {
    return apiClient.patch('/api/article/' + articleId + '/', article)
  },

  // Создаем артикл
  createArticle(article) {
    return apiClient.post('/api/article/', article)
  },

  // Редактируем инфопару
  updateInfoPair(infopairId, infopair) {
    return apiClient.patch('/api/infopair/' + infopairId + '/', infopair)
  },

  // Удаляем инфопару
  deleteInfoPair(infopairId) {
    return apiClient.delete('/api/infopair/' + infopairId)
  },

  // Создаем комментарий
  createComment(comment) {
    return apiClient.post('/api/comment/', comment)
  },

  // Редактируем комментарий
  updateComment(commentId, comment) {
    return apiClient.patch('/api/comment/' + commentId + '/', comment)
  },

  // Удаляем комментарий
  deleteComment(commentId) {
    return apiClient.delete('/api/comment/' + commentId)
  }
}
